/** Default form values for filters */
export const formDefaults = {
	status: undefined,
	supervisor: undefined,
	team: undefined,
}

/** Map calendar event data from backend to FullCalendar event format */
export const transformCalendarEvent = (row, currentUser, t) => {
	const isSelf = row.personId === currentUser.personId

	return {
		id: row.id,
		title: isSelf ? row.info || '' : t('Absence', 'Poissaolo'),
		start: row.startDate,
		end: row.endDate,
		resourceId: row.personId,
		approvers: row.approvers,
		causeCode: row.causeCode,
		icdCode: row.icdCode,
		status: row.status,
		personId: row.personId,
	}
}

/** Map person data to FullCalendar resource format */
export const mapPersonToCalendarResource = (person) => ({
	id: person.personId.toString(),
	title: person.name,
	nr: person.nr,
	...person,
})

/** Status filter options for calendar events */
export const statusOptions = (t) => [
	{ label: t('Open', 'Avoinna'), value: 'OPEN' },
	{ label: t('Approved', 'Hyväksytty'), value: 'APPROVED' },
	{ label: t('Rejected', 'Hylätty'), value: 'REJECTED' },
]

/**
 * Build supervisor filter options from current user's supervisors.
 * Deduplicates if supervisor1 and supervisor2 are the same person.
 */
export const supervisorOptions = (currentUser) => {
	const supervisors = []

	if (currentUser?.controlDetails?.supervisor) {
		supervisors.push({
			label: currentUser.controlDetails.supervisor.personName,
			value: currentUser.controlDetails.supervisor.personNumber,
		})
	}

	if (currentUser?.controlDetails?.supervisor2) {
		const isDuplicate = supervisors.some((s) => s.value === currentUser.controlDetails.supervisor2.personNumber)
		if (!isDuplicate) {
			supervisors.push({
				label: currentUser.controlDetails.supervisor2.personName,
				value: currentUser.controlDetails.supervisor2.personNumber,
			})
		}
	}

	return supervisors
}
